import React from 'react';

const Pricing = () => {
  return (
    <section id="pricing" className="py-16 bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-neutral-900">Transparent Pricing</h2>
        <p className="text-center text-neutral-600 mb-12 max-w-2xl mx-auto">
          Simple, clear pricing with no hidden charges
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-primary-600 to-primary-800 text-white p-8 text-center">
              <h3 className="text-3xl font-bold mb-2">FASTag Complete Package</h3>
              <div className="text-5xl font-bold my-4">₹400</div>
              <p className="text-primary-100">One-time payment (₹200 refundable)</p>
            </div>

            <div className="p-8">
              <div className="space-y-6">
                <div className="flex items-start pb-6 border-b border-neutral-200">
                  <div className="bg-primary-100 rounded-full p-3 mr-4">
                    <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="text-lg font-semibold text-neutral-900">Tag Cost / Issuance Fee</h4>
                      <span className="text-2xl font-bold text-primary">₹100</span>
                    </div>
                    <p className="text-neutral-600">One-time non-refundable fee for issuing the RFID tag</p>
                  </div>
                </div>

                <div className="flex items-start pb-6 border-b border-neutral-200">
                  <div className="bg-secondary-100 rounded-full p-3 mr-4">
                    <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="text-lg font-semibold text-neutral-900">Security Deposit</h4>
                      <span className="text-2xl font-bold text-secondary">₹200</span>
                    </div>
                    <p className="text-neutral-600">Fully refundable deposit when closing or surrendering the tag</p>
                    <span className="inline-block mt-2 bg-secondary-100 text-green-800 text-xs font-semibold px-3 py-1 rounded-full">
                      100% Refundable
                    </span>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-primary-100 rounded-full p-3 mr-4">
                    <svg className="w-6 h-6 text-primary-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="text-lg font-semibold text-neutral-900">FASTag Balance</h4>
                      <span className="text-2xl font-bold text-primary-700">₹100</span>
                    </div>
                    <p className="text-neutral-600">Initial wallet balance ready for toll payment deductions</p>
                    <span className="inline-block mt-2 bg-primary-100 text-purple-800 text-xs font-semibold px-3 py-1 rounded-full">
                      Ready to Use
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t-2 border-neutral-200">
                <div className="bg-primary-50 rounded-lg p-6">
                  <h4 className="font-semibold text-neutral-900 mb-4">Important Notes:</h4>
                  <ul className="space-y-2 text-sm text-neutral-700">
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span><strong>Refundable Portion:</strong> Out of ₹400, ₹200 is refundable if you deactivate/surrender the tag without outstanding dues</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span><strong>Usable Balance:</strong> You start with ₹100 directly available in your linked wallet for toll payments</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span><strong>Delivery Fee:</strong> Delivery charges (₹50-₹100) may apply depending on location and will be added at checkout</span>
                    </li>
                  </ul>
                </div>
              </div>

              <a href="#customer-form" className="mt-8 block w-full bg-gradient-to-r from-primary-600 to-primary-800 text-white text-center py-4 rounded-lg font-semibold hover:from-primary-700 hover:to-primary-900 transition shadow-lg">
                Get Started Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
